import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CatalogComponent } from '@htx/catalog';

@NgModule({
  declarations: [],
  imports: [CommonModule, CatalogComponent],
  exports: [CatalogComponent]
})
export class SharedModule {}
